import React, { useEffect } from 'react';
import { MdChat, MdChatBubble } from 'react-icons/md';
import { Container, Sponsor, SponsorGrid } from './styles';
import { Button } from '../../components/Button/styles';
import Sponsors from '../SponsorsPage';
import Particles from 'react-particles-js';
import ImageSliderBackground from '../../components/ImageBackgroundSlider';
import RodapeLP from '../Home/modules/RodapeLP';
import Whatsapp from '../../components/Whatsapp';
import { ContactIcons } from 'src/components/MenuOld';
import { getYear } from 'date-fns';

const FooterLayout: React.FC = ({ children }) => {
  return (<><div style={{ position: 'relative', zIndex: 0, display: 'block' }}>

    {/* <ImageSliderBackground slides={['/apoio/fundo1.jpg', '/apoio/fundo2.jpg', '/apoio/fundo3.jpg']} /> */}
    <div style={{ width: '100%', marginTop: '10px' }} />

    {window?.location?.pathname?.indexOf('/patrocinadores') < 0 ? <div tabIndex={0} className='gap-bg column ' style={{ position: 'relative', minHeight: '10vh', padding: '0px 15px', background: '#fff', zIndex: 900000 }}>

      <div className='full-width ' style={{ zIndex: 1 }}>


        <Sponsors />

      </div>



    </div> : <></>}

    <div className='globalFooter' style={{ position: 'relative', alignItems: 'flex-end' }}>
      <div>

        <a href="/politica"><p>Termos de cancelamento e reembolso</p></a>
        <Whatsapp text={`Olá, estou no SUERGS 2025`} message="Fale conosco" />
      </div>

    </div>
  </div>

  </>
  );
};

export default FooterLayout;
